import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { PrenosUcetniJednotkaDataService } from '../prenos-ucetni-jednotka-data/prenos-ucetni-jednotka-data.service';
import { Field, DetailService, FormSettings } from '../shared/detail/detail.service';
import { UcetniJednotkaDataService } from '../ucetni-jednotka-data/ucetni-jednotka-data.service';
import {MapperKeys} from "../shared/crud/abstractions/base-crud";

export class PrenosUcetniJednotkaFormSettings implements FormSettings {
  fieldsNew: Field[] = [
    { name: 'kodUj', title: 'Účetní jednotka', type: 'autocomplete', required: true, maxLength: 255 },
    { name: 'aktivniOd', title: 'Aktivní Od', type: 'date', required: true},
    { name: 'aktivniDo', title: 'Aktivní Do', type: 'date', required: true}
    ];
  fieldsEdit: Field[] = [
    { name: 'kodUj', title: 'Kód účení jednotky', type: 'string', required: true, maxLength: 255, readonly: true},
    { name: 'nazev', title: 'Název účetní jednotky', type: 'string', maxLength: 255, readonly: true },
    { name: 'aktivniOd', title: 'Aktivní Od', type: 'date'},
    { name: 'aktivniDo', title: 'Aktivní Do', type: 'date'},
  ];
}

@Injectable()
export class PrenosUcetniJednotkaDetailService extends DetailService {
  public allKodUj: any[]=[];
  constructor(private prenosUcetniJednotkaDataService: PrenosUcetniJednotkaDataService,
    private ucetniJednotkaDataService: UcetniJednotkaDataService,
    )
  {
    super(prenosUcetniJednotkaDataService, new PrenosUcetniJednotkaFormSettings());

    this.autocompleteRefresh();
  }

  public autocompleteRefresh(){
    const mapped = this.ucetniJednotkaDataService.setMapper({key: MapperKeys.MaxResultCount, value: 2000})
    this.ucetniJednotkaDataService.getAll({ params: mapped }).then(x => {
      x.forEach(kodUj => this.allKodUj.push(kodUj.kod))

      this.prenosUcetniJednotkaDataService.getAll(null).then(y => {

        let vytvoreneKody: any[] = [];
        y.forEach(item => {vytvoreneKody.push(item.kodUj)} );
        let kodyBezVytvorenych = x.filter(item => !(vytvoreneKody.includes(item.kod)));

        kodyBezVytvorenych.forEach(item => item.displayValue = item.kod + " - " + item.nazev);

        let observableKodField = {
          observable: of(kodyBezVytvorenych),
          optionName: 'displayValue',
          optionValue: 'kod',
        };

        let field = this.settings.fieldsNew.find(x => x.name === 'kodUj');
        if (field) {
          field.observable = observableKodField;
        }
      });
    });
  }
}
